import { render, staticRenderFns } from "./CandidaturesList.vue?vue&type=template&id=663890c3"
import script from "./CandidaturesList.vue?vue&type=script&lang=js"
export * from "./CandidaturesList.vue?vue&type=script&lang=js"
import style0 from "./CandidaturesList.vue?vue&type=style&index=0&id=663890c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports